import axios from 'axios';
import {REQUEST_URL} from '../config/urls';

const erroTurma = (erro) => {
  return {
    type: "ERRO_TURMAS",
    erro
  }
}

const salvarTurma = (turma) => {
  return {
    type: "SALVAR_TURMAS",
    turma
  }
}

const deletarTurma = (id) => {
  return {
    type: "REMOVER_TURMAS",
    id
  }
}

export const adicionarTurma = (turma) => {
  return dispatch => {
    return axios.post(`${REQUEST_URL}/turmas`, turma).then((response) => {
      dispatch(salvarTurma(response.data));
    }).catch(error => {
      dispatch(erroTurma(error.response.data.error));
    });
  }
}

export const removerTurma = (id) => {
  return dispatch => {
    return axios.delete(`${REQUEST_URL}/turmas/${id}`).then(() => {
      dispatch(deletarTurma(id));
    }).catch(error => {
      dispatch(erroTurma(error.response.data.error));
    });
  }
}


// WEBPACK FOOTER //
// ./src/actions/TurmaActions.js